import cx from 'classnames'
import { ReactNode } from 'react'
import {
  SanityButtonStyle,
  SanityFontCase,
} from '@data/sanity/queries/types/link'
import { getPageUrl, PageType } from '@lib/routes'
import Button, {
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  getButtonColor,
  getButtonIconAlignment,
  getButtonSize,
  getButtonVariant,
} from '@components/buttons/button'
import LinkFrame from './frame'
import BaseInternalLink from './base-internal-link'

interface InternalLinkProps {
  pageType: PageType
  pageSlug?: string
  id?: string
  tabIndex?: number
  'aria-label'?: string
  buttonVariant?: ButtonVariant
  buttonSize?: ButtonSize
  buttonColor?: ButtonColor
  buttonStyles?: SanityButtonStyle
  isButton?: boolean
  onClick?: () => void
  fontCase?: SanityFontCase
  className?: string
  children?: ReactNode
}

const InternalLink = ({
  pageType,
  pageSlug,
  id,
  tabIndex,
  'aria-label': ariaLabel,
  buttonVariant,
  buttonSize,
  buttonColor,
  buttonStyles,
  isButton,
  onClick,
  fontCase,
  className,
  children,
}: InternalLinkProps) => {
  const pageUrl = getPageUrl(pageType, pageSlug)

  const internalLink = (
    <BaseInternalLink href={pageUrl} onClick={onClick}>
      <Button
        id={id}
        role="link"
        tabIndex={tabIndex}
        aria-label={ariaLabel}
        variant={buttonVariant ?? getButtonVariant(buttonStyles?.variant)}
        size={buttonSize ?? getButtonSize(buttonStyles?.size)}
        color={buttonColor ?? getButtonColor(buttonStyles?.color)}
        icon={buttonStyles?.icon}
        iconAlignment={getButtonIconAlignment(buttonStyles?.iconAlignment)}
        className={cx(
          {
            btn: isButton,
            'w-full': buttonStyles?.isFullWidth,
          },
          fontCase ?? '',
          className,
        )}
      >
        {children}
      </Button>
    </BaseInternalLink>
  )

  return buttonStyles?.frame ? (
    <LinkFrame buttonStyles={buttonStyles}>{internalLink}</LinkFrame>
  ) : (
    internalLink
  )
}

export default InternalLink
